import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2, Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-[#FDF8F3]" data-id="element-77">
      <div className="max-w-3xl mx-auto text-center" data-id="element-78">
        <FadeIn data-id="element-79">
          <h2 className="text-4xl md:text-5xl text-[#2D2A26] mb-6" data-id="element-80">
            Última pregunta
          </h2>
          <p className="text-xl text-[#6B6560] leading-relaxed mb-12" data-id="element-81">
            Si hoy te sentís "funcionando por fuera y temblando por dentro"…
            <br className="hidden md:block" data-id="element-82" />
            ¿preferís seguir improvisando o tener un protocolo que te sostiene
            cuando tu cuerpo se prende fuego?
          </p>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-[#E8DED5] relative overflow-hidden" data-id="element-83">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#1A6B5A] to-[#C4785B]" data-id="element-84"></div>

            <div className="mb-8" data-id="element-85">
              <span className="text-sm font-bold tracking-wider text-[#C4785B] uppercase" data-id="element-86">
                Oferta Especial
              </span>
              <div className="flex items-center justify-center mt-2 gap-3" data-id="element-87">
                <span className="text-2xl text-[#6B6560] line-through opacity-60" data-id="element-88">
                  $590 UYU
                </span>
                <span className="text-5xl font-serif text-[#2D2A26]" data-id="element-89">
                  $269 UYU
                </span>
              </div>
              <p className="text-[#6B6560] mt-2" data-id="element-90">
                Pago único. Acceso de por vida.
              </p>
            </div>

            <div className="space-y-4 mb-10 text-left max-w-sm mx-auto" data-id="element-91">
              <div className="flex items-center" data-id="element-92">
                <CheckCircle2 className="w-5 h-5 text-[#1A6B5A] mr-3 flex-shrink-0" data-id="element-93" />
                <span className="text-[#2D2A26]" data-id="element-94">
                  Ebook PDF "Ansiedad Hormonal"
                </span>
              </div>
              <div className="flex items-center" data-id="element-95">
                <CheckCircle2 className="w-5 h-5 text-[#1A6B5A] mr-3 flex-shrink-0" data-id="element-96" />
                <span className="text-[#2D2A26]" data-id="element-97">
                  Tracker imprimible 14 días
                </span>
              </div>
              <div className="flex items-center" data-id="element-98">
                <CheckCircle2 className="w-5 h-5 text-[#1A6B5A] mr-3 flex-shrink-0" data-id="element-99" />
                <span className="text-[#2D2A26]" data-id="element-100">Checklists AM/PM/Noche</span>
              </div>
              <div className="flex items-center" data-id="element-101">
                <CheckCircle2 className="w-5 h-5 text-[#1A6B5A] mr-3 flex-shrink-0" data-id="element-102" />
                <span className="text-[#2D2A26]" data-id="element-103">Guión de consulta médica</span>
              </div>
            </div>

            <Button size="lg" className="w-full md:w-auto min-w-[250px] mb-6" onClick={() => {
            trackAddToCart();
            window.location.href = 'https://nocheserena.com/cart/51980702875941:1';
          }} data-id="element-104">
              Descargar Protocolo — $269 UYU
            </Button>

            <div className="flex items-center justify-center text-xs text-[#6B6560] gap-2" data-id="element-105">
              <Lock className="w-3 h-3" data-id="element-106" />
              <span data-id="element-107">Pago seguro y encriptado</span>
            </div>
          </div>

          <div className="mt-12 text-sm text-[#6B6560] max-w-2xl mx-auto opacity-80" data-id="element-108">
            <p className="mb-2 font-bold" data-id="element-109">Importante</p>
            <p data-id="element-110">
              Esto no reemplaza atención profesional. No promete curar. Promete
              algo mejor: un plan concreto cuando estás en modo supervivencia.
              Si estás en crisis severa, por favor buscá ayuda médica inmediata.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}